module.exports = Object.getPrototypeOf
